export enum DocumentStatusEnum {
    Prepared = "Prepared",
}